import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import SearchBox from 'components/site/SearchBox';
import EquipmentWebAPIUtils from 'utils/EquipmentWebAPIUtils';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';
import { titleize } from "underscore.string";
class EquipmentNumberSearch extends Component {
    constructor(props) {
        super(props);
        //  TODO: add debouncing, error handling, etc.
        this.clear = () => {
            this.setState({
                equipments: [],
                searchText: '',
            });
        };
        this.handleChange = (searchText) => {
            const fullText = searchText;
            if (searchText.indexOf(',') > -1) {
                const idx = searchText.lastIndexOf(',');
                searchText = searchText.slice(idx + 1, searchText.length);
            }
            else if (searchText.indexOf(' ') > -1) {
                const idx = searchText.lastIndexOf(' ');
                searchText = searchText.slice(idx + 1, searchText.length);
            }
            this.setState({
                searchText: searchText,
                fullText: fullText,
            });
        };
        this.handleEquipmentSearch = (params) => {
            EquipmentWebAPIUtils.searchEquipment(params).then((resp) => {
                const equipments = resp.entity.items;
                if (this.props.onSearchCompleted) {
                    this.props.onSearchCompleted(equipments);
                }
                this.setState({
                    equipments,
                });
            }, (err) => console.log('EquipmentSearch error: ', err));
        };
        this.handleSearch = (nGram) => {
            const params = {
                equipment_id: nGram,
            };
            let id = nGram;
            if (id.indexOf(',') > -1) {
                const idx = id.lastIndexOf(',');
                params.equipment_id = id.slice(idx + 1, id.length);
            }
            else if (id.indexOf(' ') > -1) {
                const idx = id.lastIndexOf(' ');
                params.equipment_id = id.slice(idx + 1, id.length);
            }
            this.handleEquipmentSearch(params);
        };
        this.clickedRun = () => {
            this.props.onRun(this.state.fullText);
        };
        this.renderItem = (item) => {
            return (React.createElement("a", { className: "list-group-item", style: { textDecoration: 'none' }, key: item.value },
                React.createElement("div", { className: "list-group-item-heading flex flex-row text-base" },
                    React.createElement("div", { className: "rounded text-sm text-white px-2 bg-green" }, item.equipment_id),
                    item.owner && item.owner._id ? (React.createElement("div", { className: "ml-2" }, item.owner.company_name)) : (React.createElement("div", { className: "ml-2" }, item.owner)),
                    item._equipmentType && item._equipmentType.trim() !== '' && (React.createElement("div", { className: "rounded text-sm text-white px-2 bg-blue-dark" }, item._equipmentType)))));
        };
        this.state = {
            equipmentNumbers: [],
            equipments: [],
            searchText: '',
            fullText: '',
        };
    }
    handleUserSelect(value, item) {
        this.clear();
        this.setState((prevState) => {
            let searchText = prevState.fullText;
            if (searchText.indexOf(',') > -1) {
                const idx = searchText.lastIndexOf(',');
                searchText = searchText.slice(0, idx) + ',' + item.equipment_id;
            }
            else if (searchText.indexOf(' ') > -1) {
                const idx = searchText.lastIndexOf(' ');
                searchText = searchText.slice(0, idx) + ' ' + item.equipment_id;
            }
            else {
                searchText = item.equipment_id;
            }
            return Object.assign(Object.assign({}, prevState), { searchText: searchText, fullText: searchText });
        });
    }
    render() {
        const { t } = this.props;
        return (React.createElement("div", null,
            React.createElement(Row, null,
                React.createElement(Col, { xs: 7 },
                    React.createElement(SearchBox, { items: this.state.equipments, value: this.state.fullText, clear: () => this.clear(), search: (nGram) => this.handleSearch(nGram), placeholder: t('SEARCH_FOR_EQUIPMENTS'), onChange: this.handleChange, onSelect: (value, item) => this.handleUserSelect(value, item), getItemValue: (item) => item.equipment_id, renderItem: this.renderItem, appendItems: true, toUpperCase: true })),
                React.createElement(Col, { xs: 1 },
                    React.createElement(Button, { bsStyle: "success", style: { marginLeft: -10 }, onClick: this.clickedRun }, titleize(t('RUN')))))));
    }
}
EquipmentNumberSearch.propTypes = {
    onRun: PropTypes.func.isRequired,
    onSearchCompleted: PropTypes.func,
};
export default withTranslation()(EquipmentNumberSearch);
